import { ModuleID } from '../types'
import { IDevLogModule } from './types'

import exceptionReporter from '@aytm/lib/common/exception-reporter'

let moduleLoaded = false
const DevLog: IDevLogModule = {
  get id() {
    return ModuleID.DEV_LOG
  },
  config(_props) {
    return DevLog
  },
  async load() {
    moduleLoaded = true
    return Promise.resolve(DevLog)
  },
  get loaded() {
    return moduleLoaded
  },
  log(...details) {
    exceptionReporter.sendTaggedMessage('swidget', String(details[0] as string), ...details.slice(1))
  },
  _log(...details) {
    if ('development' === process.env.NODE_ENV) {
      // eslint-disable-next-line no-console
      console.debug(...details)
    }
  },
  error(error, ...details) {
    exceptionReporter(error, ...details)
  },
  moduleLog(module, ...details) {
    DevLog.log(`SW[${module.id}]:`, ...details)
  },
  _moduleLog(module, ...details) {
    DevLog._log(`SW[${module.id}]:`, ...details)
  },
  moduleError(module, error, ...details) {
    DevLog.error(error, `SW[${module.id}]:`, String(error as string), ...details)
  }
}

export default DevLog
